<app-nav></app-nav>
<app-message></app-message>
<div class="container">
  <router-outlet></router-outlet>
</div>
